// Sort options + sort-key -> GraphQL `order` mapping for the Share feeds
// (Discover + Meine Beiträge). Kept out of the pill component so Fast Refresh
// stays happy (a .tsx exporting both a component and constants warns).

export const SORT_OPTIONS = [
  { id: "new", labelId: "sort.new" },
  { id: "old", labelId: "sort.old" },
  { id: "top", labelId: "sort.top" },
  { id: "az", labelId: "sort.az" },
] as const;

export type SortKey = (typeof SORT_OPTIONS)[number]["id"];

// The generated SortOrder enum is awkward to import as a value, so the order
// objects are plain literals; callers cast their query input as needed.
const ORDERS: Record<SortKey, Record<string, "ASC" | "DESC">> = {
  new: { publishedOn: "DESC" },
  old: { publishedOn: "ASC" },
  top: { rating: "DESC" },
  az: { name: "ASC" },
};

export function sortOrderFor(key: SortKey): Record<string, "ASC" | "DESC"> {
  return ORDERS[key];
}
